/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupDetailInputDto { 
    id?: number;
    groupName: string;
    chairmanMobileNumber?: string | null;
    groupRegion: string;
    groupDistrict: string;
    groupWard?: string | null;
    officeNumber?: string | null;
    groupTypeId?: number;
    memberTypeId?: number | null;
    policyId?: number | null;
    branchId?: number | null;
    relationshipManagerId?: number | null;
    referenceNumber?: string | null;
    readonly surname?: string | null;
    readonly middleName?: string | null;
    readonly name?: string | null;
    frequency?: string | null;
    meetingDay?: string | null;
    meetingDate?: string | null;
}

